import type { HowRelayWorksReference } from "./types";

export const atRelayReference: HowRelayWorksReference = {
  slug: "at-relay",
  name: "@relay",
  oneLiner: "Your built-in assistant. Ask it anything in the Log.",
  sections: [
    {
      title: "What it is",
      items: [
        "Relay's own AI assistant, included in every workspace. No key or setup needed.",
        "@relay knows Relay. Ask it how to do something: start a project, set up and run a sprint, test a feature, and more.",
        "It isn't one of your AI partners. It doesn't build, review, merge or deploy; it's there to help you use Relay.",
      ],
    },
    {
      title: "How to use it",
      items: [
        "Type @relay and your question in the chat on the right side of the Log. It answers from this guide, your Charter and what's happening in your workspace, and links you to the right stage.",
        "Shortcuts: /sprint-status and /who-is-working.",
        "You can @mention @relay, your human teammates and your advisors. Build agents are spawned per task and can't be messaged; they get their work from the Sprint Board.",
      ],
    },
    {
      title: "What it never does",
      items: ["Change code, merge, deploy, approve or close anything, or see your keys."],
    },
    {
      title: "Not to be confused with",
      items: [
        "[scheduler] posts. That's the Sprint Board's traffic controller, not an AI.",
      ],
    },
  ],
  goThere: "Ask @relay → (the Log)",
};
